import { Component, ViewChild, ElementRef } from '@angular/core';
@Component({
  selector: 'component-iframe',
  template: '<iframe #iframe style=" width: 100%; height: 780px;" src="http://67576576576.grade5.lk"></iframe>'
})
export class ComponentIframe  {
  @ViewChild('iframe') iframe:any;

  ngAfterViewInit() {
      let content = '<button id="button" class="button" >My button </button>';
      var iframeWindow = this.iframe.contentWindow;

      if (iframeWindow) {
      }

  }
}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/lessons/components/iframe.component.ts